import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuctionService } from '../../services/AuctionService';
import { take } from 'rxjs';
import { BidRequest } from '../../requests/bidRequest';
import { Property } from '../../models/property';
import { BidResponse } from '../../models/bidResult';

@Component({ standalone: false,
  selector: 'buy-now-dialog',
  templateUrl: 'buy-now-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['buy-now-dialog.component.scss']
})
export class BuyNowDialogComponent {
  title: string= "Confirm Buy Now";
  confirmButtonText = "Confirm";
  cancelButtonText = "Cancel";

  property!: Property;
  buyNowAmount!: number;
  isBackupBuyNow: boolean = false;

  busy:boolean=false;
  resultReceived:boolean=false;
  resultCode?:number;
  resultText:string='';
  
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<BuyNowDialogComponent>, private auctionService:AuctionService) {
    if(data){
      this.property=data.property;
      this.buyNowAmount=data.buyNowAmount;
      this.isBackupBuyNow=data.isBackupBuyNow;
    }
  }

  onConfirmClick(): void {
    this.busy=true;
    var b = new BidRequest();
    b.auctionId=this.property.auction!.id;
    b.bidAmount=this.buyNowAmount;
    b.isBackup=this.isBackupBuyNow;
    this.auctionService.buyNow(b, this.property).pipe(take(1)).subscribe(r=>this.processBuyNowAuctionResult(r));
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  get canSubmit(){
    return !this.busy && !this.resultReceived;
  }

  get canCancel(){
    return !this.busy;
  }

  private processBuyNowAuctionResult(result:BidResponse){
    this.busy=false;
    this.cancelButtonText="OK";
    this.resultReceived=true;
    switch(result.code){
      case 0:
        //Not authorized
        this.title="Unauthorized"
        this.resultText='You are not authorized to bid on this auction';
        break;
      case 1:
        //Auction ended
        this.title="Rejected"
        this.resultText='Sorry, but the auction just ended';
        break;
      case 2:
        //Sale pending
        this.title="Rejected"
        this.resultText='Sorry, but the auction just entered "Sale Pending" status';
        break;
      case 3:
        //Bids suspended
        this.title="Rejected"
        this.resultText='Sorry, but bidding just has been suspended';
        break;
      case 4:
        //Price mismatch
        this.title="Rejected"
        this.resultText='Sorry, but there is a price mismatch';
        break;
      case 5:
        //Buy Now accepted
        this.title="Accepted"
        this.resultText='Buy Now accepted - Look out for email instruction on how to proceed';
        break;
      default:
        //Unknown error
        this.title="Error"
        this.resultText='An error occured, try again later';
        break;
    }
  }

}